/**
 * UI language persists via i18next + localStorage (i18nextLng).
 * User preferences API (UpdateUserPreferences / GetUserPreferences) has no locale
 * field in this app — device/browser choice is the source of truth.
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import fr from "./locales/fr.json";
import rw from "./locales/rw.json";

export const SUPPORTED_LANGUAGES = [
  { code: "en", native: "English", english: "English", flagCountry: "United States" },
  { code: "fr", native: "Français", english: "French", flagCountry: "France" },
  { code: "rw", native: "Ikinyarwanda", english: "Kinyarwanda", flagCountry: "Rwanda" },
];

const HTML_LANG_BY_CODE = { en: "en", fr: "fr", rw: "rw" };

function setHtmlLang(lng) {
  if (typeof document === "undefined") return;
  const code = (lng || "en").split("-")[0];
  document.documentElement.lang = HTML_LANG_BY_CODE[code] || "en";
}

function normalizeStoredLanguage() {
  const code = (i18n.language || i18n.resolvedLanguage || "en").split("-")[0];
  if (code === "en" || code === "fr" || code === "rw") return Promise.resolve();
  return i18n.changeLanguage("en");
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      rw: { translation: rw },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "fr", "rw"],
    defaultNS: "translation",
    ns: ["translation"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
  })
  .then(() => normalizeStoredLanguage())
  .then(() => {
    setHtmlLang(i18n.resolvedLanguage || i18n.language);
  });

i18n.on("languageChanged", (lng) => {
  setHtmlLang(lng);
});

export default i18n;
